class ListStatsControls {
    constructor($statsRoot) {
        this.$statsRoot = $statsRoot;

        this.totalFormatString = this.$statsRoot.data("totalText");
        this.rangedFormatString = this.$statsRoot.data("rangedText");
        this.emptyString = this.$statsRoot.data("emptyText");

        this.isShowingRange = false;

        this.values = {
            total: 0,
            numberVisible: 0,
            start: 0
        };
    }

    update() {
        let formatString = this.totalFormatString;

        if (this.values.total === 0 && this.emptyString) {
            formatString = this.emptyString;
        } else if (this.values.numberVisible > 0 && this.values.total > this.values.numberVisible && this.rangedFormatString) {
            formatString = this.rangedFormatString;
        }

        this.$statsRoot.text(this.replacePlaceholders(formatString));
    }

    replacePlaceholders(input) {
        let keys = Object.keys(this.values);

        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            input = input.replace(`{${key}}`, this.values[key]);
        }

        input = input.replace("{end}", this.values.start + this.values.numberVisible - 1);

        return input;
    }

    set start(value) {
        this.values.start = value;
    }

    set numberVisible(value) {
        this.values.numberVisible = value;
    }

    set total(value) {
        this.values.total = value;
    }

    setVisibility(value) {
        this.$statsRoot.toggleClass("display-none", !value);
    }
}
export default ListStatsControls;
